import { lazy } from 'react';

const CoaEntryMaintenance = lazy(() =>
  import('../pages/CoaEntryMaintenance/index.js').then((module) => ({
    default: module.CoaEntryMaintenance,
  })),
);

const entryMaintenanceRoute = {
  public: [],
  auth: [
    {
      name: 'coa_entry_maintenance',
      path: '/finance-and-accounting/coa-entry-maintenance',
      component: CoaEntryMaintenance,
    },
  ],
};

export default entryMaintenanceRoute;
